









































import { GeekItem } from '@/models';
import { GeeksWithdrawal, WaitingWithdrawalForm } from '@/models/admin-panel';
import { ToastsService, buildGeekName } from '@/utils';
import { Actions } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'RejectWithdrawalModal',
  props: {
    waitingWithdrawal: Object as () => GeeksWithdrawal,
  },
  data() {
    return {
      reason: '',
      loader: {
        isRequestPending: false,
      },
    };
  },
  computed: {
    geekName(): string {
      return buildGeekName(this.waitingWithdrawal?.geek);
    },
  },
  methods: {
    async rejectWithdrawal() {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      this.loader.isRequestPending = true;
      try {
        const fromData = {
          geekId: this.waitingWithdrawal.geek.id,
          reason: this.reason,
          transactionIds: this.waitingWithdrawal.transactions.map(e => e.id),
        } as WaitingWithdrawalForm;

        await this.$store.dispatch(Actions.gCoins.rejectWithdrawal, fromData);

        const toastText = this.$t(
          'admin-panel.gcoins.tabs.waiting-withdrawals.rejected',
          { geekName: this.geekName },
        ) as string;
        ToastsService.warning(toastText);
        this.$bvModal.hide('reject-withdrawal-modal');
        this.$emit('refresh');
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    resetModal() {
      this.reason = '';
    },
  },
});
